import React from "react";
import {
  Box,
  Typography,
  Alert,
  CircularProgress,
  Card,
  CardContent,
  Stack,
} from "@mui/material";

import MedicationCard from "./MedicationCard";

const MedicationList = ({
  medications = [],
  reminderStatuses = new Map(),
  loading = false,
  error = null,
  onEdit,
  onDelete,
  onAdherenceChange,
  canEnableMoreAlerts = true,
  emptyMessage = "No medications added yet.",
  trackingSummaries = new Map(), // Now passed as prop
  trackingLoading = false, // Now passed as prop
  hideEmptyState = false, // The page says it instead
}) => {
  // A bare spinner, as on the Allergies page. Skeletons drew three tall fake
  // cards, which read as content on a page that may well be empty.
  if (loading) {
    return (
      <Box sx={{ py: 4, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    );
  }

  if (medications.length === 0) {
    if (hideEmptyState) return null;
    return (
      <Card>
        <CardContent sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="h6" gutterBottom>
            {emptyMessage}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Get started by adding your first medication above.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    // One full-width card per row, the same stack as the MasterChart sections.
    <Stack spacing={1.5}>
      {medications.map((medication) => {
        const trackingSummary = trackingSummaries.get(medication.id);

        return (
          <MedicationCard
            key={medication.id}
            medication={medication}
            reminderStatus={reminderStatuses.get(medication.id)}
            trackingSummary={trackingSummary}
            onEdit={onEdit}
            onDelete={onDelete}
            onAdherenceChange={onAdherenceChange}
            canEnableMoreAlerts={canEnableMoreAlerts}
          />
        );
      })}
    </Stack>
  );
};

export default MedicationList;
